<template>
    <div class="quiz-form">
        <div class="form-section">
            <label>Nom du quiz</label>
            <input type="text" v-model="name" placeholder="Nom du quiz">
        </div>
        
        <table class="notation">
            <tr>
                <th>Nombre de point par question "très confiant"</th>
                <td>
                    <input type="number" v-model="notation.nbPointHigh">
                </td>
            </tr>

            <tr>
                <th>Nombre de point par question "Moyennement confiant"</th>
                <td>
                    <input type="number" v-model="notation.nbPointMedium">
                </td>
            </tr>

            <tr>
                <th>Nombre de point par question "Peu confiant"</th>
                <td>
                    <input type="number" v-model="notation.nbPointLow">
                </td>
            </tr>

            <tr>
                <th>Malus par question "très confiant"</th>
                <td>
                    <input type="number" v-model="notation.malusHigh">
                </td>
            </tr>

            <tr>
                <th>Malus par question "Moyennement confiant"</th>
                <td>
                    <input type="number" v-model="notation.malusMedium">
                </td>
            </tr>

            <tr>
                <th>Malus par question "Peu confiant"</th>
                <td>
                    <input type="number" v-model="notation.malusLow">
                </td>
            </tr>
        </table>

        <h1>Selection des questions <div class="question-count">{{ selectedQuestions.length }}</div></h1>

        <select v-model="selectedCategory">
            <option v-for="category in categories_list" :key="category._id" :value="category._id">{{ category.name }}</option>
        </select>

        <div class="questions-list">
            <div class="question" v-for="question in questions" :key="question._id" @click="toggleQuestion(question._id)">
                <span class="material-symbols-outlined" v-if="selectedQuestions.includes(question._id)">check</span>
                <span class="material-symbols-outlined" v-else>add_2</span>
                <span>{{ question.label }}</span>
                <span>Niveau {{ question.difficulty }}</span>
            </div>
        </div>

        <div class="btn-wrapper">
            <div :class="{'allowed': isValidForm }" @click="saveForm">Enregistrer</div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            name: "",
            selectedQuestions: [],
            notation: {
                nbPointHigh: 1,
                nbPointMedium: 0.75,
                nbPointLow: 0.25,
                malusHigh: 0.5,
                malusMedium: 0.25,
                malusLow: 0,
            },
            selectedCategory: undefined,
            categories_list: [],
            questions: [],
        }
    },
    methods: {
        async createQuiz() {
            await axios.post(this.$store.getters.get_api_url + 'academy/quiz-models/', this.body);
        },
        async updateQuiz(quizId) {
            await axios.put(this.$store.getters.get_api_url + 'academy/quiz-models/' + quizId, this.body);
        },
        async loadCategories() {
            const result = await axios.get(this.$store.getters.get_api_url + 'academy/categories');
            this.categories_list = result.data;
            this.selectedCategory = result.data[0]?._id
        },
        async loadQuestions() {
            const result = await axios.get(this.$store.getters.get_api_url + 'academy/questions/' + this.selectedCategory);
            this.questions = result.data;
        },
        toggleQuestion(id) {
            if (this.selectedQuestions.includes(id)) {
                this.selectedQuestions = this.selectedQuestions.filter(questionId => questionId != id);
            } else {
                this.selectedQuestions.push(id);
            }
        },
        async saveForm() {
            if (!this.isValidForm) return;

            const quizId = this.$route.params.quizId;

            if (!quizId) {
                await this.createQuiz();
            } else {
                await this.updateQuiz(quizId);
            }

            this.$router.replace('/academy-admin/quiz-model');
        }
    },
    watch: {
        selectedCategory() {
            this.loadQuestions()
        }
    },
    computed: {
        isValidForm() {
            if (this.name == '') return false;
            else if (this.selectedQuestions.length == 0) return false;
            return true;
        },
        body() {
            return {
                name: this.name, 
                answersIds: this.selectedQuestions,
                notation: this.notation,
            }
        },
    },
    async mounted() {
        this.loadCategories();

        const quizId = this.$route.params.quizId;

        if (quizId) {
            const res = await axios.get(this.$store.getters.get_api_url + 'academy/find-model/' + quizId);
            this.name = res.data.name;
            this.notation = res.data.notation;
            this.selectedQuestions = res.data.answers.map(a => a.questionId);
        }
    }
}
</script>

<style scoped>
.quiz-form {
    padding: 20px;
}

h1 {
    display: flex;
    align-items: center;
}
.question-count {
    height: 40px;
    width: 40px;
    margin: 5px;
    background-color: #FB984B;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
    font-size: 14px;
}

table.notation {
    width: 100%;
    table-layout: fixed;
}
table.notation th, 
table.notation th {
    font-size: 14px;
    padding: 10px;
}
table.notation th {
    text-align: left;
    background-color: #0A1C6B;
    color: white;
}
table.notation td {
    position: relative;
}
table.notation td input {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    text-align: center;
    border: none;
}

table.notation tr:first-child th:first-child {
    border-top-left-radius: 10px;
}
table.notation tr:first-child td:last-child input {
    border-top-right-radius: 10px;
}
table.notation tr:last-child th:first-child {
    border-bottom-left-radius: 10px;
}
table.notation tr:last-child td:last-child input {
    border-bottom-right-radius: 10px;
}

select {
    padding: 10px;
    border-radius: 10px;
    border: 1px solid lightgrey;
}

.questions-list {
    display: flex;
    flex-direction: column;
    padding: 20px;
}
.questions-list .question {
    background-color: white;
    padding: 10px;
    display: flex;
    align-items: center;
    border-radius: 10px;
    cursor: pointer;
    margin: 5px 0;
}
.questions-list .question span:nth-child(1) {
    flex-basis: 30px;
}
.questions-list .question span:nth-child(2) {
    flex: 1;
}
.questions-list .question span:nth-child(3) {
    flex-basis: 80px;
    font-weight: bold;
}

.btn-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}

.btn-wrapper div {
    cursor: not-allowed;
    padding: 15px;
    background-color: lightgrey;
    border-radius: 10px;
    font-weight: bold;
}
.btn-wrapper .allowed {
    cursor: pointer;
    background-color: #FB984B;
    color: white;
}
</style>